import { API_BASE_URL } from "src/config/apiBase";
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { getDecryptedUserFromCookie } from '../utils/getCookie';
import ImageModalEquip from '../Modal/ImageModalProd';
import { decryptToken } from '../utils/getToken';

const BrandModal = ({ isOpen, setIsOpen, data, setData, isEdit = false, fetchCategories }) => {
    const [brandName, setBrandName] = useState('');
    const [position, setPosition] = useState('');
    const [status, setStatus] = useState(null);
    const [parentBrand, setParentBrand] = useState(null);
    const [image, setImage] = useState(null);
    const [images, setImages] = useState([]);
    const [customer_no, setCustomerNo] = useState('');
    const [customer_email, setCustomerEmail] = useState('')
    const [pdf_url, setPdfUrl] = useState("");
    const [description, setDescription] = useState('')
    const [showImageModal, setShowImageModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const userDetails = getDecryptedUserFromCookie("gta_mainstateuser");
    const urlmain = API_BASE_URL;
    const token = decryptToken("accessToken") || ""
    // Fetch images from media library
    const fetchImages = async () => {
        try {
            const res = await fetch(`${urlmain}/api/images/${userDetails.main_id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            const data = await res.json();
            setImages(data);
        } catch (error) {
            console.error(error);
        }
    };

    // Dummy category data
    const [categories, setCategories] = useState([]);

    const fetchBrand = async () => {
        try {
            const response = await fetch(`${urlmain}/brand/getall`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            })
            const res = await response.json();
            setCategories(res.data);

        } catch (error) {
            console.error(error)
        }
    }
    // Select options
    const brandOptions = categories.map(cat => {
        const parent = categories.find(c => c.id === cat.parentId);
        return {
            value: cat.id,
            label: parent ? `— ${cat.name}` : cat.name,
        };
    });
    const parentBrandOptions = [{ value: "", label: "None (Top-level)" }, ...brandOptions];
    const statusOptions = [
        { value: 'Active', label: 'Active' },
        { value: 'Inactive', label: 'Inactive' },
    ];

    const handleImageSelect = (img) => {
        const selectedUrl = `${urlmain}${img.url}`;
        setImage(selectedUrl);
        setShowImageModal(false);
    };

    // Prefill form when editing
    useEffect(() => {
        if (isEdit && data) {
            setBrandName(data.name || '');
            setPosition(data.position || '');
            setStatus(statusOptions.find(s => s.value === data.status) || null);
            setParentBrand(parentBrandOptions.find(p => p.value === data.brand_id) || null);
            setImage(data.image_url || null);
            setCustomerEmail(data.customer_email);
            setCustomerNo(data.customer_no);
            setDescription(data.description)
        } else {
            setBrandName('');
            setPosition('');
            setStatus(null);
            setParentBrand(null);
            setImage(null);
        }
    }, [isEdit, data]);

    useEffect(() => {
        fetchImages();
        fetchBrand();
    }, []);

    if (!isOpen) return null;

    // Submit handler (create or update)
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!brandName || !status) {
            toast.error("Please fill required fields");
            return;
        }

        setLoading(true);

        const payload = {
            name: brandName,
            position,
            status: status.value,
            brand_id: parentBrand?.value || null,
            image_url: image,
            main_id: userDetails.main_id,
            customer_no,
            customer_email,
            description
        };

        try {
            const endpoint = isEdit
                ? `${urlmain}/brand/${data.id}`
                : `${urlmain}/brand`;

            const method = isEdit ? 'PUT' : 'POST';

            const res = await fetch(endpoint, {
                method,
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${token}`

                },
                body: JSON.stringify(payload),
            });

            const result = await res.json();
            if (!res.ok) {
                toast.error(`${result.message}`)
            } else {


                toast.success(isEdit ? "Brand updated successfully!" : "Brand added successfully!");
                setIsOpen(false);
                fetchCategories();
                // setData(prev => isEdit
                //     ? prev.map(item => item.id === data.id ? result : item)
                //     : [...prev, result]
                // );
            }
        } catch (error) {
            console.error(error);
            toast.error("Error saving brand");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="custom-modal-overlay">
            <div className="custom-modal-content">
                <h2 className="oms-modal-title">{isEdit ? "Edit Brand" : "Add Brand"}</h2>
                <form className="oms-modal-form" onSubmit={handleSubmit}>

                    {/* Brand Name */}
                    <div className="oms-form-group">
                        <label htmlFor="brandName" className="oms-form-label">Brand Name</label>
                        <input
                            type="text"
                            id="brandName"
                            value={brandName}
                            onChange={(e) => setBrandName(e.target.value)}
                            placeholder="Enter brand name"
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="description" className="oms-form-label">Description</label>
                        <textarea
                            type="text"
                            id="description"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            placeholder="Enter description"
                        />
                    </div>

                    {/* Image */}
                    <div className="oms-form-group ome-form-button2">
                        <label htmlFor="image" className="oms-form-label">Logo</label>
                        <button type="button" onClick={() => setShowImageModal(true)}>Select Image</button>
                        {image && <img src={image} alt="Selected" style={{ width: 80, marginTop: 10 }} />}
                    </div>

                    {/* Parent Brand */}
                    <div className="oms-form-group">
                        <label htmlFor="parentBrand" className="oms-form-label">Parent Brand</label>
                        <Select
                            id="parentBrand"
                            options={parentBrandOptions}
                            value={parentBrand}
                            onChange={setParentBrand}
                            placeholder="Select parent brand"
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="customer_no" className="oms-form-label">Customer-Care Mobile</label>
                        <input
                            type="text"
                            id="customer_no"
                            value={customer_no}
                            onChange={(e) => setCustomerNo(e.target.value)}
                            placeholder="Enter Customer Mobile"
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="customer_email" className="oms-form-label">Customer Email</label>
                        <input
                            type="text"
                            id="customer_email"
                            value={customer_email}
                            onChange={(e) => setCustomerEmail(e.target.value)}
                            placeholder="Enter Customer Email"
                        />
                    </div>

                    {/* Position */}
                    <div className="oms-form-group">
                        <label htmlFor="position" className="oms-form-label">Position</label>
                        <input
                            type="text"
                            id="position"
                            value={position}
                            onChange={(e) => setPosition(e.target.value)}
                            placeholder="Enter position"
                        />
                    </div>

                    {/* Status */}
                    <div className="oms-form-group">
                        <label htmlFor="status" className="oms-form-label">Status</label>
                        <Select
                            id="status"
                            options={statusOptions}
                            value={status}
                            onChange={setStatus}
                            placeholder="Select status"
                        />
                    </div>

                    {/* Image Selector Modal */}
                    <ImageModalEquip
                        show={showImageModal}
                        handleClose={() => setShowImageModal(false)}
                        images={images}
                        onImageSelect={handleImageSelect}
                        multiple={false}
                        setImages={setImages}
                    />

                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>Cancel</button>

                        <button
                            type="submit"
                            disabled={loading}
                            className={`${loading
                                ? "opacity-50 cursor-not-allowed"
                                : "hover:bg-black"
                                }`}
                        >
                            {loading
                                ? (isEdit ? "Updating..." : "Submitting...")
                                : (isEdit ? "Update" : "Submit")
                            }
                        </button>

                    </div>
                </form>
            </div>
        </div>
    );
};

export default BrandModal;
